import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Heroes({ heroes }) {
  const [info, setInfo] = useState(null);
  const navigate = useNavigate();

  const handleOpen = () => {
    getHeroDetail();
    navigate(`/heroes/${heroes.key}`);
  };

  const getHeroDetail = () => {
    axios.get(`https://overfast-api.tekrop.fr/heroes/${heroes.key}?locale=fr-fr`)
      .then((res) => {
        setInfo(res.data);
      })
      .catch(error => console.error('Error fetching hero details:', error));
  };

  return (
    <div className="hero_profile" onClick={handleOpen}>
      <img src={heroes.portrait} alt={heroes.name} />
      <p>{heroes.name}</p>
    </div>
  );
}

export default Heroes;
